import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    recallParkedSaleContainer: {
        maxWidth: '100%',
    },
    popup: {
        width: 400,
        height: 150,
        overflow: 'auto'
    },
    lineDetailIcon: {
        cursor: 'pointer'
    },
    disabled: {
        color: '#AAAAAA !important',
        cursor: 'default !important'
    },
    infoButton: {
        color: '#337ab7',
        width: 18,
        height: 17,
        cursor: 'pointer'
    },
    grid: {
        'maxWidth': '100% !important',
        'height': 442,
        '& .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td.dx-focused': {
            background: '#e6e6e6 !important'
        },
        '& .dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td:focus': {
            outline: 'unset'
        },
        '& .dx-datagrid-focus-overlay': {
            border: 'none',
        },
    },
});
